import { render, staticRenderFns } from "./ReportesAtenciones.vue?vue&type=template&id=1d524d30"
import script from "./ReportesAtenciones.vue?vue&type=script&lang=js"
export * from "./ReportesAtenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports